import { useContext, useMemo } from "react";
import { StoryNotFoundError } from "../errors/not-found";
import { Loadable } from "../loadable";
import { DivisionServiceContext } from "../services";

/**
 * Resolves the story a session belongs to — read when a player restarts, so the
 * new session starts from the stored story rather than the one in memory.
 *
 * Goes through the single-story loadable, not the division's catalogue: the
 * caller wants one story, and pulling the whole catalogue to find it is what
 * the share-link payload was narrowed to avoid.
 */
export const useGameLoadable = function (gameId?: string) {
  const divisionService = useContext(DivisionServiceContext);

  return useMemo(() => {
    return Loadable.create(async () => {
      if (!gameId) return undefined;

      try {
        return await divisionService.loadableGame(gameId).ensuredValue();
      } catch (e) {
        // A story that is gone — unpublished while it was being played — leaves
        // the caller to fall back to the session it already holds, the way the
        // catalogue lookup's miss did. Anything else is a real failure.
        if (e instanceof StoryNotFoundError) return undefined;
        throw e;
      }
    });
  }, [gameId]);
};
